import { AppState } from '../reducers/index'
import { Dispatch } from 'react'
import { Action } from 'redux'
import Pagination from '../models/Pagination'
import fetchApi, { HttpMethod, getToken } from './fetchApi'
import { pushAlert } from '../actions/alert'
import { updateNotifications } from '../actions/notifications'
import { updateComplaintCount } from '../actions/complaint/updateComplaintCount'

type RequestStatus = 'FETCH' | 'FETCHING' | 'ERROR'

export type RequestActionType =
  | 'CONFIG'
  | 'LOGIN'
  | 'PASSWORD_RECOVERY'
  | 'PROFILE'
  | 'CLIENT_BULK_UPSERT'
  | 'CLIENT_DETAIL'
  | 'CLIENT_LIST'
  | 'CLIENT_UPSERT'
  | 'PERSON_BULK_UPSERT'
  | 'PERSON_DETAIL'
  | 'PERSON_LIST'
  | 'PERSON_CHECK'
  | 'PERSON_UPSERT'
  | 'COMPLAINT_BULK_UPSERT'
  | 'COMPLAINT_DETAIL'
  | 'COMPLAINT_LIST'
  | 'COMPLAINT_UPSERT'
  | 'COMPLAINT_MESSAGE'
  | 'COMPLAINT_MESSAGE_DETAIL'
  | 'COMPLAINT_MESSAGE_UPSERT'
  | 'COMPLAINT_MESSAGE_UPLOADFILE'
  | 'COMPLAINT_MESSAGE_DOWNLOADFILE'
  | 'COMPLAINT_INTERNAL_MESSAGE'
  | 'COMPLAINT_INTERNAL_MESSAGE_DETAIL'
  | 'COMPLAINT_INTERNAL_MESSAGE_UPSERT'
  | 'COMPLAINT_INTERNAL_MESSAGE_UPLOADFILE'
  | 'COMPLAINT_INTERNAL_MESSAGE_DOWNLOADFILE'
  | 'COMPLAINT_TYPE_LIST'
  | 'COMPLAINT_COUNT'
  | 'UPDATE_COMPLAINT_COUNT'
  | 'SESSION'
  | 'SESSION_CLOSED'
  | 'TOKEN_EXPIRED'
  | 'INVOICE_DETAIL'
  | 'INVOICE_LIST'
  | 'INVOICE_AZURE'
  | 'INVOICE_TOTALS'
  | 'INVOICESTATUS_UPSERT'
  | 'BOUNCED_RECEIPT_DETAIL'
  | 'BOUNCED_RECEIPT_LIST'
  | 'BOUNCED_RECEIPT_AZURE'
  | 'BOUNCED_RECEIPT_TOTALS'
  | 'ELECTRONIC_STOCK_DETAIL'
  | 'ELECTRONIC_STOCK_LIST'
  | 'CURRENT_ACCOUNT_LIST'
  | 'CURRENT_ACCOUNT_DETAIL'
  | 'CURRENT_ACCOUNT_TOTALS'
  | 'CURRENT_ACCOUNT_SUMMARY'
  | 'ORDER_DETAIL'
  | 'ORDER_LIST'
  | 'ORDER_CLEAR'
  | 'ORDER_STATUSES'
  | 'ORDER_TOTALS'
  | 'REMITTANCE_LIST'
  | 'PREPAYMENT_DETAIL'
  | 'PREPAYMENT_DISCOUNTS'
  | 'PREPAYMENT_LIST'
  | 'PREPAYMENT_COUNT'
  | 'USE_PREPAYMENT_DETAIL'
  | 'NOTIFICATION_DETAIL'
  | 'NOTIFICATION_LIST'
  | 'NOTIFICATION_PEND_LIST'
  | 'NOTIFICATION_UPSERT'
  | 'MASS_NOTIFICATION_DETAIL'
  | 'MASS_NOTIFICATION_LIST'
  | 'MASS_NOTIFICATION_UPSERT'
  | 'SET_CLASS'
  | 'UPDATE_CREDENTIALS'
  | 'CLEAR'
  | 'UPDATE_NOTIFICATIONS'
  | 'NOTIFY_CLIENTS'
  | 'SETTLEMENT_RECORD_LIST'
  | 'GOAL_DETAIL'  
  | 'GOAL_LIST'
  | 'GOAL_UPSERT'
  | 'GOAL_BULK_UPSERT'
  | 'GOAL_STATS'
  | 'PRODUCT_DETAIL'
  | 'PRODUCT_LIST'
  | 'PRODUCT_UPSERT'
  | 'PRODUCTBRAND_DETAIL'
  | 'PRODUCTBRAND_LIST'
  | 'PRODUCTBRAND_UPSERT'
  | 'PRODUCTSECTION_DETAIL'
  | 'PRODUCTSECTION_LIST'
  | 'PRODUCTSECTION_UPSERT'
  | 'PRODUCTGROUP_DETAIL'
  | 'PRODUCTGROUP_LIST'
  | 'PRODUCTGROUP_UPSERT'
  | 'PRODUCTSUBGROUP_DETAIL'
  | 'PRODUCTSUBGROUP_LIST'
  | 'PRODUCTSUBGROUP_UPSERT'
  | 'PRODUCTMEASUREMENT_DETAIL'
  | 'PRODUCTMEASUREMENT_LIST'
  | 'PRODUCTMEASUREMENT_UPSERT'
  | 'PRODUCTMEASUREMENTTYPE_DETAIL'
  | 'PRODUCTMEASUREMENTTYPE_LIST'
  | 'PRODUCTMEASUREMENTTYPE_UPSERT'
  | 'PREPAYMENT_CLEAR'
  | 'PREORDER_PRODUCT_LIST'
  | 'PREORDER_PRODUCT_LIST_CLEAR'
  | 'PREORDER_ALL_PRODUCT_LIST'
  | 'PREORDER_SURPLUS_PRODUCT'
  | 'PREORDER_LIST'
  | 'PREORDER_CTRL_LIST'
  | 'PREORDER_DATA'
  | 'PREORDER_CLEAR'
  | 'PREORDER_UPSERT'
  | 'PREORDER_DELETE'
  | 'PREORDER_DETAIL_DATA'
  | 'PREORDER_DETAIL_LIST'
  | 'PREORDER_DETAIL_UPSERT'
  | 'PREORDER_DETAIL_DELETE'
  | 'PREORDER_DETAIL_CLEAR'
  | 'PREORDER_HOLD_UPLOADFILE'
  | 'PREORDER_REJECT_UPLOADFILE'
  | 'PREORDER_BULK_DETAIL_UPSERT'
  | 'PREORDER_BULK_DETAIL_UPDATE_PRICE'
  | 'GENERAL_DESC_LIST'
  | 'DISCOUNT_LIST'
  | 'CURRENT_PRICE_LIST'
  | 'COUNTRIES_LIST'
  | 'COUNTRY_DETAIL'
  | 'COUNTRY_UPSERT'
  | 'INFO_CURRENT_PRICE_LIST'
  | 'INFO_CURRENT_PRICE_LIST_CLEAR'
  | 'DELIVERY_LOCATION_DETAIL'
  | 'DELIVERY_LOCATION_LIST'
  | 'DELIVERY_AREA_LIST'
  | 'DELIVERY_CLEAR'
  | 'PROVINCE_LIST'
  | 'PROVINCE_DETAIL'
  | 'LOCALITY_LIST'
  | 'LOCALITY_DETAIL'
  | 'LOGISTIC_WARNING_LIST'
  | 'CARRIER_DETAIL'
  | 'CARRIER_LIST'
  | 'LOG_DETAIL'
  | 'LOG_LIST'
  | 'INCOTERMS_DETAIL'
  | 'INCOTERMS_LIST'
  | 'VENDOR_DETAIL'
  | 'VENDOR_LIST'
  | 'LINKED_VENDORS_LIST'
  | 'LINKED_VENDORS_DELETE'
  | 'LINKED_VENDORS_UPSERT'
  | 'UNIGIS'

export interface ApiAction extends Action<RequestActionType> {
  requestStatus?: RequestStatus,
  newApiState: ApiState,
  response?: any,
}

export interface ApiState {
  isFetching: boolean,
  didInvalidate: boolean,
  error?: Error,
}

export const initialApiState: ApiState = {
  isFetching: false,
  didInvalidate: false,
}


export interface PaginatedApiState extends ApiState {
  pagination: Pagination
}

export const initialPaginatedApiState: PaginatedApiState = {
  ...initialApiState,
  pagination: {
    size: 100,
    count: 0,
    page: 0,
  }
}

export const tokenExpired = (): ApiAction => ({
  type: 'TOKEN_EXPIRED',
  newApiState: {
    isFetching: false,
    didInvalidate: true,
  },
})

export const dispatchResponse = (type) => (dispatch, _, response) => dispatch({ type, ...response })
export const alertMessage = (message, isError?) => (dispatch) => dispatch(pushAlert(message, isError))
export const alertError = (message) => alertMessage(message, true)

const requestAction = (type: RequestActionType, params?: string) => (route: string, method: HttpMethod, body?: any, header?: any, formDataContent?: any,
  handleResponse: (dispatch: Dispatch<any>, getState: () => AppState, response: any) => void = _ => { },
  handleError: (dispatch: Dispatch<any>, err: Error) => void = _ => { }) =>
  async (dispatch: Dispatch<ApiAction>, getState: () => AppState) => {
    let token = getToken()

    try {
      dispatch({
        type,
        requestStatus: 'FETCHING',
        newApiState: {
          isFetching: true,
          didInvalidate: false,
        }
      })

      const search = params || ''
      const response = await fetchApi(token, method, `${route}${search}`, body, header, formDataContent)

      if (response.error) throw new Error(response.error)

      dispatch({
        type,
        requestStatus: 'FETCH',
        response,
        newApiState: {
          isFetching: false,
          didInvalidate: false,
        }
      })

      response.complaintCount && updateComplaintCount(response.complaintCount)(dispatch)
      response.notifications && updateNotifications(response.notifications)(dispatch)

      handleResponse(dispatch, getState, response)

    } catch (error) {
      
      dispatch({
        type,
        requestStatus: 'ERROR',
        newApiState: {
          isFetching: false,
          didInvalidate: true,
          error: error as Error
        }
      })

      if ((error as any)?.message?.includes('401') || (error as any)?.status === 401) {
        dispatch(tokenExpired())
      }
      
      handleError(dispatch, error as Error)
    }
  }

export default requestAction